import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { React, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { isAuthenticated, getUserRole } from "./utils/authUtils";
import "react-toastify/dist/ReactToastify.css";
import ClientPage from "./ClientPage";
import { Auth } from "./components/AuthPage";
import { ADMIN_ROLE } from "./constants/constants";
import { AdminDashBoard } from "./components/AdminPage";
import MenuPage from "./components/ClientPage/MenuPage/MenuPage";
import Profile from "./components/ClientPage/Profile/Profile";

const AppRoutes = () => {
  const location = useLocation();
  const [auth, setAuth] = useState(isAuthenticated());
  const [role, setRole] = useState(getUserRole());

  useEffect(() => {
    setAuth(isAuthenticated());
    setRole(getUserRole());
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<ClientPage />} />
      <Route path="/menu" element={<MenuPage />} />

      {/* Profile route - only accessible for authenticated non-admin users */}
      <Route
        path="/profile"
        element={
          auth ? (
            role === ADMIN_ROLE ? (
              <Navigate to="/admin/dashboard" replace />
            ) : (
              <Profile />
            )
          ) : (
            <Navigate to="/signin" replace />
          )
        }
      />

      <Route
        path="/signin"
        element={
          auth ? (
            role === ADMIN_ROLE ? (
              <Navigate to="/admin/dashboard" replace />
            ) : (
              <Navigate to="/" replace />
            )
          ) : (
            <Auth isSignIn={true} />
          )
        }
      />

      <Route
        path="/signup"
        element={
          auth ? (
            role === ADMIN_ROLE ? (
              <Navigate to="/admin/dashboard" replace />
            ) : (
              <Navigate to="/" replace />
            )
          ) : (
            <Auth isSignIn={false} />
          )
        }
      />

      <Route
        path="/admin/dashboard"
        element={
          auth && role === ADMIN_ROLE ? (
            <AdminDashBoard />
          ) : (
            <Navigate to="/signin" replace />
          )
        }
      />

      <Route
        path="/admin/*"
        element={<Navigate to="/admin/dashboard" replace />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer position="top-center" autoClose={3000} />
    </Router>
  );
};

export default App;
